import React from "react";
import Mobile from "../../sections/CustomerDashboard/Dashboard/Mobile";
import { AdminPageTitle } from "../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../components/common/Containers/DashboardMainContainer";
import { CUSTOMER_CENTERED_PAGE_TITLE_CLASS } from "../../sections/CustomerDashboard/shared/customerLayoutSpec";

const CustMobile = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${CUSTOMER_CENTERED_PAGE_TITLE_CLASS}`}>
        Update mobile number
      </AdminPageTitle>
      <div className="flex justify-center min-h-screen">
        <Mobile />
      </div>
    </DashboardMainContainer>
  );
};

export default CustMobile;
